var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPass(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#0f357f",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.27 18.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0px",
    d: "m8.13,0C5.57,0,3.49,2.08,3.49,4.65v2.32c-1.93,0-3.49,1.56-3.49,3.49v4.65c0,1.93,1.56,3.49,3.49,3.49h9.3c1.93,0,3.49-1.56,3.49-3.49v-4.65c0-1.93-1.56-3.49-3.49-3.49v-2.32c0-2.57-2.08-4.65-4.65-4.65Zm5.81,10.46v4.65c0,.64-.52,1.16-1.16,1.16H3.49c-.64,0-1.16-.52-1.16-1.16v-4.65c0-.64.52-1.16,1.16-1.16h9.3c.64,0,1.16.52,1.16,1.16Zm-8.13-3.49v-2.32c0-1.28,1.04-2.32,2.32-2.32s2.32,1.04,2.32,2.32v2.32h-4.65Z"
  }), /*#__PURE__*/React.createElement("circle", {
    strokeWidth: "0px",
    cx: 8.13,
    cy: 12.78,
    r: 1.16
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPass);
export default __webpack_public_path__ + "static/media/icon-pass.8d6a96e5f138e1f19ee3c4b8ffc8aa9f.svg";
export { ForwardRef as ReactComponent };